import React from 'react';
import { Link } from 'react-router-dom';
import './PersonalCare.css';

function PersonalCare() {
  return (
    <div className="personal-care-page">
      {/* Header/Navigation */}
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><h1>Malach <span>Healthcare</span></h1></Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
          <Link to="/#contact" className="btn btn-primary">Book Consultation</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Personal Care Services</h1>
          <p>Compassionate support for daily living, delivered with dignity and respect</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-intro">
          <h2>Understanding Your Needs</h2>
          <p>
            At Malach Healthcare, we understand that needing personal care support can feel overwhelming 
            for individuals and for the families who love them. Whether due to aging, illness, disability, 
            or recovery after hospitalization, everyday tasks can become challenging. Our Personal Care 
            Services are designed to meet these needs with compassion, respect, daily comfort and reliability, 
            so clients can continue living safely and comfortably in their own homes.
          </p>
          <p>
            Everyone's situation is different. Some clients need a little help to stay independent, while 
            others require more consistent, hands-on support. Our caregivers take the time to understand 
            each person's physical needs, preferences, routines, and cultural values. We don't believe in 
            one-size-fits-all care: we believe in personalized care that fits your life.
          </p>
        </div>

        <div className="services-list">
          <h2>Our Personal Care Services Include</h2>
          <div className="services-grid-detail">
            <div className="service-item">
              <div className="service-item-icon">🛁</div>
              <h3>Bathing & Hygiene</h3>
              <p>Assistance with bathing, grooming, and personal hygiene</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">👔</div>
              <h3>Dressing Assistance</h3>
              <p>Help with dressing and toileting</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🚶</div>
              <h3>Mobility Support</h3>
              <p>Mobility and transfer assistance</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🍽️</div>
              <h3>Meal Preparation</h3>
              <p>Meal preparation and feeding assistance</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💊</div>
              <h3>Medication Reminders</h3>
              <p>Medication reminders (as permitted)</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🏠</div>
              <h3>Light Housekeeping</h3>
              <p>Light housekeeping related to personal care</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">📅</div>
              <h3>Daily Routines</h3>
              <p>Support with daily routines and activities</p>
            </div>
          </div>
          <p className="services-note">
            Every service is delivered with patience, privacy, and a focus on preserving dignity.
          </p>
        </div>

        <div className="caregivers-section">
          <h2>Our Caregivers</h2>
          <p>
            Our caregivers are carefully selected and trained not only for their skills, but for their 
            kindness, empathy, and professionalism. We know that trust is essential when inviting someone 
            into your home. That's why Malach Healthcare prioritizes clear communication, consistency in 
            caregivers, and dependable scheduling.
          </p>
        </div>

        <div className="family-support">
          <h2>Supporting Families Too</h2>
          <p>
            Caring for a loved one can be emotionally and physically exhausting. Our Personal Care Services 
            are also here to support families, providing peace of mind, reducing caregiver stress, and 
            ensuring loved ones receive attentive, compassionate care even when you can't be there.
          </p>
          <p>
            Our goal is not just to help with tasks, but to enhance quality of life. By supporting daily 
            needs, we help clients maintain independence, confidence, and a sense of control over their lives.
          </p>
        </div>

        <div className="why-choose-us">
          <h2>Why Choose Malach Healthcare?</h2>
          <ul className="benefits-list">
            <li>✓ Person-centered, compassionate care</li>
            <li>✓ Respect for dignity, privacy, and individual values</li>
            <li>✓ Reliable, trained caregivers</li>
            <li>✓ Flexible care plans tailored to changing needs</li>
            <li>✓ Commitment to safety, comfort, and well-being</li>
          </ul>
        </div>

        <div className="closing-message">
          <p>
            At Malach Healthcare, personal care is more than a service—it's a relationship built on trust, 
            compassion, and genuine concern for your well-being.
          </p>
          <p className="highlight">
            Let us walk alongside you or your loved one with care you can depend on, every day.
          </p>
          <Link to="/#contact" className="btn btn-primary btn-large">Book A Free Consultation</Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Malach <span>Healthcare</span></h3>
            <p>Empowering golden years with compassionate care.</p>
            <div className="social-links">
              <a href="#facebook">📘</a>
              <a href="#twitter">🐦</a>
              <a href="#instagram">📷</a>
              <a href="#linkedin">💼</a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
                <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/personal-care">Personal Care</Link></li>
              <li><Link to="/#services">Companion Care</Link></li>
              <li><Link to="/#services">Dementia Care</Link></li>
              <li><Link to="/specialty-care">Specialty Care</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 740 Main St<br />Waltham, MA 02451</p>
            <p>📞 (781) 697-6330</p>
            <p>✉️ info@malachhealthcare.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 | All Rights Reserved | Malach Healthcare</p>
        </div>
      </footer>
    </div>
  );
}

export default PersonalCare;
